import QAndARoleFilter from './QAndARoleFilter.component';

export default QAndARoleFilter;